module.exports = __webpack_public_path__ + "img/society-epicurus-avatar.d6670a14.png";